module.exports = __webpack_public_path__ + "static/media/crybanners_sm3.bbe2d1d9.jpg";